import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import * as firebase from 'firebase/app';
import 'firebase/auth';
import { faEye, faComment, faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import * as moment from 'moment';
import { getSetISOWeekYear } from 'ngx-bootstrap/chronos/units/week-year';

@Component({
  selector: 'app-appbar',
  templateUrl: './appbar.component.html',
  styleUrls: ['./appbar.component.css']
})
export class AppbarComponent implements OnInit, OnDestroy {

  currentUser;
  store;
  faEye = faEye;
  faComment = faComment;
  faPaperPlane = faPaperPlane;
  views = 0;
  conversations = [];
  doNotRepeat = [];
  chatWith: any = {};
  messages = [];
  message;
  authChangeListener;
  chatListener;
  viewsListener;

  @ViewChild('conversationsModal') conversationsModal;
  @ViewChild('chatModal') chatModal;

  constructor(private router: Router) {

    this.authChangeListener = firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.currentUser = user;

        this.viewsListener = firebase.firestore().collection('views').doc(user.uid).onSnapshot(snapshot => {
          this.views = snapshot.data().total;
        });

        this.getStore();

        this._listenNewMessages();

      }
    });
    
  }

  ngOnInit() { }

  ngOnDestroy(): void {
    this.authChangeListener.unsubscribe();
    this.viewsListener.unsubscribe();
    this.chatListener.unsubscribe();
  }

  getStore() {
    firebase.firestore().collection('store').doc(this.currentUser.uid).get().then(store => {
      this.store = store.data();
    });
  }

  logoff() {
    firebase.auth().signOut().then(() => {
      this.router.navigate(['/login']);
    });
  }

  openConversationsModal() {
    this.conversations = [];
    this._getConversations();
  }

  _listenNewMessages() {
    firebase.firestore().collection('conversations').where('to', '==', this.currentUser.uid).onSnapshot(value => {
      this._newMessageBell();
    });
  }

  _newMessageBell() {
    let audio = new Audio();
    audio.src = 'https://codeskulptor-demos.commondatastorage.googleapis.com/descent/gotitem.mp3';
    audio.load();
    audio.muted = false;
    audio.play();
    audio.onended = function() {
      audio.remove();
    }
  }

  _getConversations() {
    let _messagesJson = {};
    firebase.firestore().collection('conversations').where('from', '==', this.currentUser.uid).orderBy('createdAt', 'asc').get().then(sent => {
      firebase.firestore().collection('conversations').where('to', '==', this.currentUser.uid).orderBy('createdAt', 'asc').get().then(received => {
        var messages = [];
        sent.docs.map((message) => {
          messages.push(message.data());
        });
        received.docs.map((message) => {
          messages.push(message.data());
        });
        messages.sort((a, b) => (a.createdAt > b.createdAt) ? 1 : ((b.createdAt > a.createdAt) ? -1 : 0)); 
        messages.map((conversation) => {
          var other = conversation['from'] == this.currentUser.uid ? conversation['to'] : conversation['from'];
          _messagesJson[other] = conversation;
        });
        this.conversations = Object.values(_messagesJson);
        this.conversations.sort((a, b) => (b.createdAt > a.createdAt) ? 1 : ((a.createdAt > b.createdAt) ? -1 : 0)); 

        this.conversationsModal.show();
      });
    });
  }

  openChat(userWithId, name) {
    this.conversationsModal.hide();
    this.chatListener = firebase.firestore().collection('chat').doc(this.currentUser.uid).collection(userWithId).orderBy('createdAt').onSnapshot((chat) => {
      this.chatWith = { id: userWithId, name };
      this.messages = [];
      chat.docs.map(message => {
        this.messages.push(message.data());
      });
      setTimeout(() => {
        this.scrollChatToBottom();
      }, 1000);
    });
    this.chatModal.show();
  }

  send() {
    if (this.message && this.message.length > 0) {
      firebase.firestore().collection('chat').doc(this.currentUser.uid).collection(this.chatWith.id).add({
        sender: true,
        message: this.message,
        createdAt: firebase.firestore.FieldValue.serverTimestamp()
      });
      firebase.firestore().collection('chat').doc(this.chatWith.id).collection(this.currentUser.uid).add({
        message: this.message,
        createdAt: firebase.firestore.FieldValue.serverTimestamp()
      });
      firebase.firestore().collection('conversations').add({
        from: this.currentUser.uid,
        fromName: this.store.name,
        to: this.chatWith.id,
        toName: this.chatWith.name,
        message: this.message,
        createdAt: firebase.firestore.FieldValue.serverTimestamp()
      });
      this.message = '';
    }
  }

  date(date) {
    if (date && date.seconds) {
      return moment.unix(date.seconds).format('DD/MM/YYYY HH:mm');
    }
  }

  scrollChatToBottom() {
    let chatBody = document.getElementById('chatBody');
    chatBody.scrollTop = chatBody.scrollHeight;
  }

}
